const UUID_FALLBACK_POLICY = {
  hexadecimalRadix: 16,
  randomNibbleRange: 16,
  variantMask: 0x3,
  variantBits: 0x8,
} as const;

/**
 * Generates the opaque correlation IDs used between SDK frames and callbacks.
 *
 * Modern browsers use the native UUID implementation. The arithmetic fallback
 * preserves the existing browser-compatibility behavior; these identifiers
 * correlate messages and are never accepted as authentication capabilities.
 */
export function generateId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const randomNibble = Math.floor(Math.random() * UUID_FALLBACK_POLICY.randomNibbleRange);
    const value =
      character === 'x'
        ? randomNibble
        : (randomNibble & UUID_FALLBACK_POLICY.variantMask) | UUID_FALLBACK_POLICY.variantBits;
    return value.toString(UUID_FALLBACK_POLICY.hexadecimalRadix);
  });
}
